import React from 'react';
import { useStyles } from './SessionsCopyDialog.styles';
import { FormControlLabel, Grid, TextField, TextFieldProps } from '@material-ui/core';
import { CheckboxOne } from '../../../components/CheckboxOne/CheckboxOne.component';

interface BasicDataFormSessionInfoProps {
  textInputRef: React.MutableRefObject<TextFieldProps | undefined>;
  name: string;
  validName: boolean;
  isTrainingSession: boolean;
  handleIsTrainingSession: (val: boolean) => void;
  type: string;
  year: number;
  month: number;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const BasicDataFormSessionInfo: React.FC<BasicDataFormSessionInfoProps> = ({
  textInputRef,
  name,
  validName,
  isTrainingSession,
  handleIsTrainingSession,
  type,
  year,
  month,
  handleChange,
}: BasicDataFormSessionInfoProps) => {
  const classes = useStyles();

  return (
    <>
      <Grid container style={{ justifyContent: 'center', margin: '12px 0px' }}>
        <div className={classes.middleText}>Dodaj nową sesję egzaminacyjną</div>
      </Grid>
      <Grid container style={{ justifyContent: 'center', marginTop: 12 }}>
        <Grid xs={12} container item style={{ justifyContent: 'center' }}>
          <TextField
            id="name"
            inputRef={textInputRef}
            error={!validName}
            helperText={validName ? undefined : 'Podana nazwa sesji egzaminacyjnej już istnieje'}
            className={`${classes.formInput} ${classes.formInputWidth}`}
            name={name}
            onChange={handleChange}
            label="Nazwa"
            placeholder="Nazwa"
            variant="outlined"
            inputProps={{
              style: {
                padding: '15.5px',
              },
            }}
          />
        </Grid>
        <Grid xs={12} container item style={{ justifyContent: 'center', marginTop: '12px' }}>
          <FormControlLabel
            className={`${classes.formInputWidth}`}
            control={
              <CheckboxOne
                name={'Sesja treningowa'}
                onClick={() => {
                  handleIsTrainingSession(!isTrainingSession);
                }}
                checked={isTrainingSession}
              />
            }
            label="Sesja treningowa"
          />
        </Grid>
      </Grid>
      <Grid container className={classes.paddedItem} style={{ justifyContent: 'center' }}>
        <Grid item xs={6}>
          <TextField
            id="type"
            label="Typ sesji"
            variant="outlined"
            fullWidth
            value={type}
            required
            onChange={handleChange}
            inputProps={{ 'aria-label': 'typ sesji' }}
          />
        </Grid>
      </Grid>
      <Grid container className={classes.paddedItem} style={{ justifyContent: 'center' }}>
        <Grid item xs={3}>
          <div style={{ paddingRight: 4 }}>
            <TextField
              id="year"
              label="Rok"
              variant="outlined"
              fullWidth
              value={year}
              required
              onChange={handleChange}
              type="number"
              inputProps={{
                min: '1',
                max: '9999',
                'aria-label': 'rok',
              }}
            />
          </div>
        </Grid>
        <Grid item xs={3}>
          <div style={{ paddingLeft: 4 }}>
            <TextField
              id="month"
              label="Miesiąc"
              variant="outlined"
              fullWidth
              value={month}
              required
              onChange={handleChange}
              type="number"
              inputProps={{
                min: '1',
                max: '12',
                'aria-label': 'miesiąc',
              }}
            />
          </div>
        </Grid>
      </Grid>
    </>
  );
};
